import { Component, inject, OnInit, output, signal } from '@angular/core';
import { AddSecurityCodeComponent } from '@webapp/payments/ui/components/add-security-code/add-security-code.component';
import { PaymentsListComponent } from '@webapp/payments/ui/components/payments-list/payments-list.component';
import { BackButtonComponent, ButtonComponent } from '@webapp/ui';
import { IPayment, IPaymentMP } from '../../../interfaces/payment.interface';
import { QuoterStoreService } from '../../../store/quoter-store.service';
import { IUserPaymentMethod } from '@webapp/users/interfaces/users.interface';
import { UsersService } from '@webapp/users/services/users.service';
import { firstValueFrom } from 'rxjs';
import { AddPaymentComponent } from '@webapp/payments/ui/components/add-payment/add-payment.component';
import { PAYMENT_GATEWAYS } from '@webapp/payments';
import { RiskRegistry } from '@webapp/risk-core';

@Component({
  selector: 'app-quoter-payment',
  standalone: true,
  imports: [
    AddPaymentComponent,
    ButtonComponent,
    BackButtonComponent,
    AddSecurityCodeComponent,
    PaymentsListComponent,
  ],
  templateUrl: './quoter-payment.component.html',
  styleUrl: './quoter-payment.component.scss',
})
export class QuoterPaymentComponent implements OnInit {
  private usersService = inject(UsersService);
  private quoterStateService = inject(QuoterStoreService);
  private readonly riskRegistry = inject(RiskRegistry);
  readonly quoterState = this.quoterStateService.state.asReadonly();
  EventPayment = output<IPaymentMP>();
  EventGeneratePaymentLink = output<string>();
  userPaymentMethods = signal<IUserPaymentMethod[]>({} as IUserPaymentMethod[]);
  addPaymentMethod = false;
  paymentsLoading = signal(true);
  addSecurityCode = signal(false);
  selectPaymentMethod = signal(false);

  ngOnInit(): void {
    if (this.quoterState().user.id && this.quoterState().user.isClient) {
      this.selectPaymentMethod.set(true);
      this.getPaymentMethods();
    } else {
      this.addPaymentMethod = true;
    }
  }

  toggleAddSecurityCode() {
    this.addSecurityCode.set(!this.addSecurityCode());
  }

  showAddPaymentMethod() {
    this.selectPaymentMethod.set(false);
    this.addPaymentMethod = true;
  }

  showPaymentMethods() {
    this.selectPaymentMethod.set(true);
    this.addPaymentMethod = false;
  }

  needSecurityCode() {
    return this.riskRegistry.find(this.quoterState().risk.tag)?.capabilities.requiresSecurityCode === true;
  }


  toggleAddPamymentMethod() {
    if (this.userPaymentMethods().length > 0) {
      this.selectPaymentMethod.set(true);
    } else {
      this.selectPaymentMethod.set(false);
    }

    this.addPaymentMethod = !this.addPaymentMethod;
  }

  showPaymentList() {
    const updatedPaymentMethods = this.userPaymentMethods().map((method) => ({
      ...method,
      selected: false,
    }));
    this.userPaymentMethods.set(updatedPaymentMethods);
    this.addSecurityCode.set(false);
    this.selectPaymentMethod.set(true);
  }

  setSecurityCode(securityCode: string) {
    const payment = this.quoterState().payment;
    this.quoterStateService.setState({
      payment: {
        ...payment,
        securityNumber: securityCode,
      },
    });

    this.addSecurityCode.set(false);
    this.selectPaymentMethod.set(true);
  }

  async getPaymentMethods() {
    const user = this.quoterState().user;
    const hasMercadoPago = this.quoterState().risk.paymentMethods.includes('mercado_pago');

    if(!user){
      throw new Error('User not found');
    }
    
    try {
      
      const response = await firstValueFrom(
        this.usersService.getPaymentMethods(user.id ?? '')
      );

      const filteredMethods = response.filter((method) => {
       
        if (hasMercadoPago) {
          return method.type !== 'cbu';
        }

        return true;
      });


      const updatedPaymentMethods = filteredMethods.map((method) => ({
        ...method,
        selected: false,
      }));

      if (response.length > 0) {
        this.userPaymentMethods.set(updatedPaymentMethods);
      } else {
        this.addPaymentMethod = true;
      }

      return true;
    } catch (error) {
      this.addPaymentMethod = true;
      console.error('Error al obtener los medios de pago:', error);
      return false;
    } finally {
      this.paymentsLoading.set(false);
    }
  }

  setExistingPayment(paymentValues: IPayment) {

    if (this.quoterState().risk.paymentMethods.includes(PAYMENT_GATEWAYS.MERIDIONAL)) {
      this.selectPaymentMethod.set(true);
    } else {
      this.addSecurityCode.set(true);
      this.selectPaymentMethod.set(false);
      this.addPaymentMethod = false;
    }

    this.userPaymentMethods().map((paymentMethod) => {
      return paymentMethod.id == paymentValues.id
        ? (paymentMethod.selected = true)
        : (paymentMethod.selected = false);
    });
    this.setPayment(paymentValues, true);
  }

  setPayment(paymentValues: IPayment, exist: boolean) {
    const payment: IPayment = {
      id: paymentValues.id,
      name: paymentValues.name,
      number: paymentValues.number,
      securityNumber: paymentValues.securityNumber,
      expiresAt: paymentValues.expiresAt,
      type: paymentValues.type,
      method: paymentValues.type,
      exist: exist,
    };
   
    this.quoterStateService.set('payment', payment);
  }
}
